import { render } from "./ContagemEstoque.vue?vue&type=template&id=2126c3aa&scoped=true"
import script from "./ContagemEstoque.vue?vue&type=script&lang=js"
export * from "./ContagemEstoque.vue?vue&type=script&lang=js"

import "./ContagemEstoque.vue?vue&type=style&index=0&id=2126c3aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2126c3aa"]])

export default __exports__